var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CsHeader",style:(("background-image: url(" + (_vm.contents.header) + ");"))},[_c('img',{staticClass:"logo",attrs:{"src":require("./logo.png"),"alt":"京东金融"}}),_vm._v(" "),_c('div',{staticClass:"rule"},[_c('a',{attrs:{"href":_vm.contents.rule,"clstag":"jr|keycount|zy|gz"}},[_vm._v("活动规则")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d73d2a5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CsHeader/index.vue
// module id = null
// module chunks = 